export const postCommentURL = 'customers/customers/sendComment'
export const downloadSmsURL = 'customers/marketing/sms'
